(() => {
  "use strict";
  var e = {
      d: (t, r) => {
        for (var o in r)
          e.o(r, o) &&
            !e.o(t, o) &&
            Object.defineProperty(t, o, { enumerable: !0, get: r[o] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  function DomReadyPromise() {
    return new Promise(function (e, t) {
      "loading" !== document.readyState
        ? e()
        : addEventListener("DOMContentLoaded", () => {
            e();
          });
    });
  }
  function parseHTML(e) {
    const t = document.createElement("template");
    return (t.innerHTML = e), t.content;
  }
  e.r(t),
    e.d(t, {
      DomReadyPromise: () => DomReadyPromise,
      GlobalCart: () => GlobalCart,
      GlobalLocaleLoader: () => GlobalLocaleLoader,
      ObserverLite: () => ObserverLite,
      StoreFrontApi: () => StoreFrontApi,
      _babelPolyfill: () => r,
      clearCookie: () => clearCookie,
      debounce: () => debounce,
      parseHTML: () => parseHTML,
    });
  class ObserverLite {
    constructor(e) {
      if (
        ((e = e || {}),
        (this.id = Math.floor(999999999999 * Math.random())),
        (this.settings = e),
        e.key)
      ) {
        if (
          ((window.GlobalObersverLiteInstances =
            window.GlobalObersverLiteInstances || {}),
          window.GlobalObersverLiteInstances[e.key])
        )
          return window.GlobalObersverLiteInstances[e.key];
        window.GlobalObersverLiteInstances[e.key] = this;
      }
    }
    once() {
      return new Promise((e, t) => {
        this.onceDone && e(this.onceDone);
        const r = this.subscribe((t) => {
          (t = t || !0), (this.onceDone = t), e(t), this.unsubscribe(r);
        });
      });
    }
    setOnce(e) {
      (e = e || !0), (this.onceDone = e);
    }
    next(...e) {
      this.onceDone || this.setOnce(...e),
        this.subject &&
          this.subject.length &&
          this.subject.forEach(({ callback: t }) => {
            t(...e);
          });
    }
    subscribe(e) {
      return (
        (this.subject = this.subject || []),
        (e = { callback: e, id: Math.floor(1e14 + 9e14 * Math.random()) }),
        this.subject.push(e),
        e
      );
    }
    unsubscribe(e) {
      this.subject = this.subject.filter(({ id: t }) => t !== e.id);
    }
    unsubscribeAll(e) {
      this.subject?.forEach((e) => this.unsubscribe(e)),
        e && (this.onceDone = !1);
    }
  }
  class GlobalLocaleLoader {
    constructor(e) {
      return (
        (window.GlobalLocaleLoaderObserver$ =
          window.GlobalLocaleLoaderObserver$ || new ObserverLite()),
        window.GlobalLocaleLoaderSingleton
          ? new Promise((e, t) => {
              window.GlobalLocaleLoaderObserver$.loaded
                ? e(window.GlobalLocaleLoaderSingleton)
                : window.GlobalLocaleLoaderObserver$.subscribe(() => {
                    e(window.GlobalLocaleLoaderSingleton);
                  });
            })
          : e
          ? ((window.GlobalLocaleLoaderSingleton = this),
            (this.settings = e),
            (this.ObserverLite = new ObserverLite()),
            this.subscribe(() => {
              (window.GlobalLocaleLoaderObserver$.loaded = !0),
                window.GlobalLocaleLoaderObserver$.next();
            }),
            (this.translations = e.translations),
            void this.next())
          : new Promise((e, t) => {
              window.GlobalLocaleLoaderObserver$.subscribe(() => {
                e(window.GlobalLocaleLoaderSingleton);
              });
            })
      );
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
  }
  class ShopifyUtils {
    constructor(e) {
      this.money_format = e.money_format || "£{{amount}}";
    }
    handleize(e) {
      return e
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
    parseImgUrl(e, t) {
      const r = e.includes(".png") ? "png" : "jpg";
      return `${e.split("png" == r ? ".png" : ".jpg")[0]}_${t}x.${r}`;
    }
    formatMoney(e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var r = "",
        o = /\{\{\s*(\w+)\s*\}\}/,
        i = t || this.money_format;
      function defaultOption(e, t) {
        return void 0 === e ? t : e;
      }
      function formatWithDelimiters(e, t, r, o) {
        if (
          ((t = defaultOption(t, 2)),
          (r = defaultOption(r, ",")),
          (o = defaultOption(o, ".")),
          isNaN(e) || null == e)
        )
          return 0;
        var i = (e = (e / 100).toFixed(t)).split(".");
        return (
          i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) +
          (i[1] ? o + i[1] : "")
        );
      }
      switch (i.match(o)[1]) {
        case "amount":
          r = formatWithDelimiters(e, 2);
          break;
        case "amount_no_decimals":
          r = formatWithDelimiters(e, 0);
          break;
        case "amount_with_comma_separator":
          r = formatWithDelimiters(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          r = formatWithDelimiters(e, 0, ".", ",");
      }
      return i.replace(o, r);
    }
  }
  class GlobalCart {
    constructor(e) {
      return (
        (window.GlobalCartObserver$ =
          window.GlobalCartObserver$ || new ObserverLite()),
        window.GlobalCartSingleton
          ? new Promise((e, t) => {
              window.GlobalCartObserver$.loaded
                ? e(window.GlobalCartSingleton)
                : window.GlobalCartObserver$.subscribe(() => {
                    e(window.GlobalCartSingleton);
                  });
            })
          : e
          ? ((window.GlobalCartSingleton = this),
            (this.ObserverLite = new ObserverLite()),
            (this.ShopifyUtils = new ShopifyUtils({
              money_format: e.money_format || !1,
            })),
            this.subscribe(() => {
              (window.GlobalCartObserver$.loaded = !0),
                window.GlobalCartObserver$.next();
            }),
            void this.updateData())
          : new Promise((e, t) => {
              window.GlobalCartObserver$.subscribe(() => {
                e(window.GlobalCartSingleton);
              });
            })
      );
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
    serialize(e) {
      const t = {};
      function setValue(e, t, r) {
        const o = t.pop();
        let i = e;
        for (const e of t) i[e] || (i[e] = {}), (i = i[e]);
        i[o] = r;
      }
      const r = new FormData(e);
      for (let [e, o] of r.entries()) {
        setValue(
          t,
          e.split("[").map((e) => e.replace("]", "")),
          o
        );
      }
      return t;
    }
    addToCart(e) {
      return new Promise((t, r) => {
        e || r({ description: "Sorry, there was a problem with that request" });
        e.items.filter(
          ({ id: e }) =>
            this.getLineItemsByVariantId(e)
              .map(({ quantity: e }) => e)
              .reduce((e, t) => e + t, 0) >= 6
        ).length && r({ type: "max_six" }),
          fetch("/cart/add.js", {
            method: "POST",
            body: JSON.stringify(e),
            headers: { "Content-Type": "application/json" },
          })
            .then((e) => e.json())
            .then((e) => {
              if (!e.items) throw e;
              this.updateData(), t();
            })
            .catch((e) => {
              console.log(e), r(e);
            });
      });
    }
    updateData() {
      return new Promise((e, t) => {
        this.getCartJSON().then((t) => {
          (this.cart = t), this.next({ eventType: "update" }), e();
        });
      });
    }
    updateQty(e, t, r) {
      (r = r || [{ key: e.key, qty: t }]),
        e?.properties?._bundle_id &&
          (r = r.concat(
            this.cart.items
              .filter(
                ({ properties: t }) => t?._bundle_id == e.properties._bundle_id
              )
              .map(({ key: e }) => ({ key: e, qty: 0 }))
          )),
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            updates: r.reduce((e, t) => ({ ...e, [t.key]: t.qty }), {}),
          }),
        })
          .then((e) => e.json())
          .then((e) => {
            if (!e.token) throw e;
            (this.cart = e), this.next({ eventType: "update" });
            document.dispatchEvent(
              new CustomEvent('buyxgety:update', {
                detail: {
                  cart: window.GlobalCartMain.cart
                }
              })
            );
          })
          .catch((e) => {
            console.log(e), this.next({ eventType: "error", error: e });
          });
    }
    removeItem(e) {
      fetch(e).then((e) => {
        this.next({ eventType: "update" });
      });
    }
    getCartJSON() {
      return new Promise((e, t) => {
        fetch("/cart.js")
          .then((e) => e.json())
          .then((t) => {
            e(t);
          });
      });
    }
    getLineItemsByVariantId(e) {
      return (
        (e = parseInt(e)),
        this.cart && this.cart.items
          ? this.cart.items.filter(({ variant_id: t }) => t == e)
          : []
      );
    }
    getLineItemsByProperty(e, t) {
      return this.cart && this.cart.items
        ? this.cart.items.filter((r) => {
            let o = r.properties?.[e];
            return (o = !!((null == t && o) || (o && o == t))), o;
          })
        : [];
    }
  }
  class StoreFrontApi {
        constructor(e) {
            const t = new ObserverLite({
                key: "StoreFrontApi$"
            });
            if (!e)
                return new Promise((async (e, i) => {
                    e(await t.once())
                }
                ));
            this.ObserverLite = new ObserverLite,
            this.endpoint = `${e.storeUrl}/api/${e.version}/graphql.json`,
            this.accessToken = e.accessToken,
            t.next(this)
        }
        subscribe(e) {
            return this.ObserverLite.subscribe(e)
        }
        next(e) {
            this.ObserverLite.next(e)
        }
        authFetch(e) {
            const t = {
                method: e?.method || "POST",
                headers: {
                    "Content-Type": "application/graphql",
                    "X-Shopify-Storefront-Access-Token": this.accessToken
                }
            };
            return e?.body && (t.body = e.body),
            new Promise(( (e, i) => {
                fetch(this.endpoint, t).then((e => e.json())).then((t => {
                    e(t)
                }
                )).catch((e => {
                    i(e)
                }
                ))
            }
            ))
        }
    }
  function clearCookie(e, t, r) {
    e.preventDefault(),
      t.forEach((e) => {
        (document.cookie = `${e}=; Path=/; Domain=medik8.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`),
          r && location.reload();
      });
  }
  function debounce(e, t) {
    let r;
    return function (...o) {
      clearTimeout(r),
        (r = setTimeout(() => {
          e(...o);
        }, t));
    };
  }
  const r = !0;
  var o = self;
  for (var i in t) o[i] = t[i];
  t.__esModule && Object.defineProperty(o, "__esModule", { value: !0 });
})();
